import React from "react";
import styles from "./ShopGrid.module.css";
import { BsFillBalloonHeartFill, BsFillBagHeartFill } from "react-icons/bs";
import { PiHandHeartFill } from "react-icons/pi";
import { Button } from "../Buttons/Button/Button";
import product1 from "../data/assets/Amigurumis/Dino/1.png";
import product2 from "../data/assets/Anime/OnePiece/Luffy-3.png";
import product3 from "../data/assets/Llaveros/comida/japon-comida.png";
import product4 from "../data/assets/Amigurumis/plush/sol-1.png";
import product5 from "../data/assets/Amigurumis/plush/rana-2.png";
import product6 from "../data/assets/Flores/girasol/girasol-1.png";

function ShopGrid({ setHidden, setShowShop }) {
  function onClick() {
    setHidden(true);
    setShowShop(true);
  }
  return (
    <>
      <div className={styles.grid}>
        <div className={styles.text}>
          <p className={styles.description}>Hecho a mano</p>
          <PiHandHeartFill className={styles.icon}></PiHandHeartFill>
        </div>
        <figure className={styles.shape}>
          {" "}
          <img src={product2} alt="Grid" className={styles.image}></img>
        </figure>
        <figure className={styles.shape}>
          {" "}
          <img src={product3} alt="Grid" className={styles.image}></img>
        </figure>
        <figure className={styles.shape}>
          {" "}
          <img src={product4} alt="Grid" className={styles.image}></img>
        </figure>

        <div className={styles.text}>
          <p className={styles.description}>Con amor</p>
          <BsFillBalloonHeartFill
            className={styles.icon}
          ></BsFillBalloonHeartFill>
        </div>
        <figure className={styles.shape}>
          {" "}
          <img src={product5} alt="Grid" className={styles.image}></img>
        </figure>
        <figure className={styles.shape}>
          {" "}
          <img src={product1} alt="Grid" className={styles.image}></img>
        </figure>
        <figure className={styles.shape}>
          {" "}
          <img src={product6} alt="Grid" className={styles.image}></img>
        </figure>
        <div className={styles.text}>
          <p className={styles.description}>Y cuidado en cada detalle </p>
          <BsFillBagHeartFill className={styles.icon}></BsFillBagHeartFill>
        </div>
      </div>
      <Button onClick={onClick}>Ver</Button>
    </>
  );
}

export { ShopGrid };
